import GraphicEqRoundedIcon from '@mui/icons-material/GraphicEqRounded';

export const FragmentIcon = GraphicEqRoundedIcon;
